






import { Vue, Component } from 'vue-property-decorator';
import { ncpPopup } from '@/utils/ncp';

@Component
export default class ExcelDownloadButton extends Vue {
  private windowPopupOpen(): void {
    ncpPopup('/popup/excel-download', 'EXCEL_DOWNLOAD_LIST', 1000, 800);
  }
}
